import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

const container = document.getElementById('app');
 
const root = createRoot(container!);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://123f3fe1327e45589adc68546d39c820@o459666.ingest.sentry.io/4504276281262080',
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

root.render(<App />);

reportWebVitals();
